import { FormattedMessage, useIntl } from 'react-intl';

export const graphLabels = {
    title: 'Transport graph',
    requests: 'Transport requests',
    request: 'Transport request',
    transports: 'Transports',
    transport: 'Transport',
    details: 'Details',
    select: 'Select a card or connection to inspect its details.',
    clearSelection: 'Clear selection',
    notLoaded: 'Not in loaded requests',
    referenceOnly: 'Reference only',
    referenceMatch: 'Reference match',
    pickupCheck: 'Pickup',
    pickupMatches: 'Pickup matches',
    pickupDiffers: 'Pickup differs',
    subset: 'Loaded subset',
    loaded: 'Loaded results',
    notice: 'Connections reflect the loaded results. An unconnected card does not imply completion or missing allocation.',
    dateChanged: 'Pickup date changed',
    timeChanged: 'Pickup time changed',
    notComparable: 'Pickup cannot be compared',
    handlingUnits: 'Handling units',
    unitCount: '{count, plural, one {# handling unit} other {# handling units}}',
    inspectConnection: 'Inspect connection',
    arrange: 'Arrange cards',
    map: 'Graph overview map',
    previewDemo: 'Demo controls publish to the backend and open the live graph.',
    fit: 'Fit to view',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetView: 'Reset view',
    layoutError: 'Automatic layout is unavailable. Cards are shown in two columns.',
    canvas: 'Transport request and transport graph',
    variant: 'UI variant',
    original: 'Original',
    graph: 'Graph',
    preview: 'Fixture preview · existing frontend data · not connected to the backend',
} as const;

export type GraphLabel = keyof typeof graphLabels;
export const graphMessage = (name: GraphLabel) => ({
    id: `intl-msg:sci.graph.${name}`,
    defaultMessage: graphLabels[name],
});
export const G = ({ name }: { name: GraphLabel }) => <FormattedMessage {...graphMessage(name)} />;
export const useGraphLabel = () => {
    const intl = useIntl();
    return (name: GraphLabel) => intl.formatMessage(graphMessage(name));
};
